import { render, staticRenderFns } from "./OnlineSetting.vue?vue&type=template&id=1506768e&scoped=true&"
import script from "./OnlineSetting.vue?vue&type=script&lang=js&"
export * from "./OnlineSetting.vue?vue&type=script&lang=js&"
import style0 from "./OnlineSetting.vue?vue&type=style&index=0&id=1506768e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1506768e",
  null
  
)

export default component.exports